module.exports = __webpack_public_path__ + "img/ic_32_sport_volleyball-white.1bced5a0.svg";